import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	FocusLayer,
	LayerWrapper,
	ShimLayer,
	Text,
	TokenTextAppearance,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CloseCircle } from '@volkswagen-onehub/icons-core';
import './VehicleNotFoundModal.scss';

function VehicleNotFoundModal(props: Props) {
	const { toggleVisibility, t } = props;
	const navigate = useNavigate();

	function closeModal() {
		toggleVisibility();
		navigate('/');
	}

	return (
		<ThemeProvider theme="main">
			<div className="alert-layer">
				<LayerWrapper contentCentered>
					<ShimLayer key="shim" />
					<FocusLayer size={'B'} active>
						<Container gutter={ContainerGutter.dynamic0100} padding={ContainerPadding.dynamic0200} stretchContent>
							<div className="vin-not-found-title">
								<div className="vin-not-found-icon">
									<CloseCircle variant="large" />
								</div>

								<Text appearance={TokenTextAppearance.headline500}>{t('vehicleNotFound.title')}</Text>
							</div>

							<Text appearance={TokenTextAppearance.copy200}>{t('vehicleNotFound.content')}</Text>

							<Container
								gutter={ContainerGutter.dynamic0100}
								stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
								wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b560]: 'never' }}
							>
								<CTA emphasis="secondary" onClick={() => closeModal()} tag="button" stretchContent>
									{t('general.close')}
								</CTA>

								<CTA emphasis="primary" onClick={() => closeModal()} tag="button" stretchContent>
									{t('vehicleNotFound.searchAlternative')}
								</CTA>
							</Container>
						</Container>
					</FocusLayer>
				</LayerWrapper>
			</div>
		</ThemeProvider>
	);
}

interface Props {
	toggleVisibility: () => void;
	t: any;
}

export default VehicleNotFoundModal;
